export const ANALYTIC_CODE = {
  GOOGLE_ANALYTIC_UNIVERSAL: 'GOOGLE_ANALYTIC_UNIVERSAL',
  GOOGLE_ANALYTIC_GA4: 'GOOGLE_ANALYTIC_GA4',
  GOOGLE_TAG_MANAGER: 'GOOGLE_TAG_MANAGER',
  FACEBOOK_PIXEL: 'FACEBOOK_PIXEL',
  TIKTOK_ANALYTIC: 'TIKTOK_ANALYTIC',
}
